@if (!loading) {
  <nz-page-header title="Моя профил"/>
  @if (profile.isActive) {
    <section class="mb-5 container-lg">
      <div class="row g-0 g-lg-4">
        <aside class="mb-4 col-12 col-lg-4 col-xl-3">
          <nz-sidebar-menu
            title="Меню"
            [items]="menuItems"
            [selectedItem]="selectedMenuItem"
            queryParamsHandling="replace"/>
        </aside>
        <main class="col-12 col-lg-8 col-xl-9">
          <div class="d-none d-lg-block mb-4 alert alert-primary rounded-3">
            <h5 class="m-0 d-flex align-items-center">
              <i class="me-2 fs-6" [class]="selectedMenuItem.iconClass"></i>
              <span>{{ selectedMenuItem.title }}</span>
            </h5>
          </div>
          @switch (selectedMenuItem.id) {
            @case (1) {
              <nz-profile-dashboard [profile]="profile"/>
            }
            @case (2) {
              <nz-profile-messages [targetMenuId]="selectedMenuItem.id.toString()"/>
            }
            @case (3) {
              <nz-profile-notifications [targetMenuId]="selectedMenuItem.id.toString()"/>
            }
            @case (4) {
              <nz-profile-ads [targetMenuId]="selectedMenuItem.id.toString()"/>
            }
            @case (5) {
              <nz-profile-ad-likes [targetMenuId]="selectedMenuItem.id.toString()"></nz-profile-ad-likes>
            }
            @case (6) {
              <nz-profile-wallet [profile]="profile"></nz-profile-wallet>
            }
            @case (7) {
              <nz-profile-purchases [targetMenuId]="selectedMenuItem.id.toString()"></nz-profile-purchases>
            }
            @case (8) {
              <nz-profile-sales [targetMenuId]="selectedMenuItem.id.toString()"></nz-profile-sales>
            }
            @case (9) {
              <nz-profile-user-feedbacks [targetMenuId]="selectedMenuItem.id.toString()"></nz-profile-user-feedbacks>
            }
            @case (10) {
              <nz-profile-followed-users [targetMenuId]="selectedMenuItem.id.toString()"></nz-profile-followed-users>
            }
            @case (11) {
              <nz-profile-followers [targetMenuId]="selectedMenuItem.id.toString()"></nz-profile-followers>
            }
            @case (12) {
              <nz-profile-settings [profile]="profile"></nz-profile-settings>
            }
          }
        </main>
      </div>
    </section>
  } @else {
    <section class="my-4 container-lg">
      <div class="alert alert-danger">
        <i class="me-2 text-danger fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
        <span>Профила е изтрит!</span>
      </div>
    </section>
  }
} @else {
  <nz-loader/>
}
